import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import LearnMoreArrowIcon from './LearnMoreArrowIcon';
import africaDotted from '../assets/africa-dotted.svg';
import './HeroSection.scss';

const words = [
  { text: 'The',      em: false },
  { text: 'Capital',  em: false },
  { text: 'Layer',    em: false },
  { text: 'Behind',   em: false },
  { text: 'African',  em: true  },
  { text: 'Freight',  em: false },
];

const wordVar = {
  hidden:  { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: 0.2 + i * 0.085 },
  }),
};

const fadeUp = (delay = 0) => ({
  initial:    { opacity: 0, y: 16 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay },
});

export default function HeroSection() {
  return (
    <section className="hero">
      <div className="hero__inner">
        <motion.img
          src={africaDotted}
          alt=""
          aria-hidden
          className="hero__africa-map"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
        />

        <motion.p className="hero__label" {...fadeUp(0.05)}>
          Trade Finance Infrastructure
        </motion.p>

        <h1 className="hero__headline">
          {words.map(({ text, em }, i) => (
            <Fragment key={i}>
              {i > 0 && ' '}
              <motion.span
                className={`hero__word${em ? ' hero__em' : ''}`}
                custom={i}
                variants={wordVar}
                initial="hidden"
                animate="visible"
              >
                {text}
              </motion.span>
            </Fragment>
          ))}
        </h1>

        <motion.p className="hero__sub" {...fadeUp(0.85)}>
          We finance shipments, monitor execution, and ensure reliable payments
          across African trade corridors.
        </motion.p>

        <motion.div className="hero__actions" {...fadeUp(1.0)}>
          <Link to="/contact" className="btn-learn-more">
            Get In Touch
            <LearnMoreArrowIcon />
          </Link>
        </motion.div>

        <motion.div {...fadeUp(1.15)}>
          <div className="hero__divider" />
          <div className="hero__stats">
            {[
              { num: '3-Step',   label: 'Process' },
              { num: '100%',     label: 'Shipment-Backed' },
              { num: 'Pan-Africa', label: 'Corridors' },
            ].map(({ num, label }) => (
              <div className="hero__stat" key={label}>
                <div className="hero__stat-num">{num}</div>
                <div className="hero__stat-label">{label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>

      <motion.div
        className="hero__scroll-hint"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.8 }}
      >
        <div className="hero__scroll-line" />
      </motion.div>
    </section>
  );
}

